import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { AppStoreIcon, GooglePlayIcon } from './StoreIcons';
import { storeLinks } from '../lib/storeLinks';
import { STORE_PLATFORMS, useStorePlatform } from '../lib/storePlatform';

const heroButtons = [
    {
        href: storeLinks.ios,
        icon: AppStoreIcon,
        eyebrow: 'Download on the',
        label: 'App Store',
    },
    {
        href: storeLinks.android,
        icon: GooglePlayIcon,
        eyebrow: 'Get it on',
        label: 'Google Play',
    },
];

const ctaButtons = [
    {
        href: storeLinks.ios,
        icon: AppStoreIcon,
        label: 'App Store',
        className: 'store-pill store-pill--primary',
        trail: ArrowRight,
    },
    {
        href: storeLinks.android,
        icon: GooglePlayIcon,
        label: 'Google Play',
        className: 'store-pill store-pill--secondary',
        trail: Play,
    },
];

function ExternalLink({ href, className, onClick, children, ariaLabel }) {
    return (
        <a
            href={href}
            className={className}
            target="_blank"
            rel="noreferrer"
            onClick={onClick}
            aria-label={ariaLabel}
        >
            {children}
        </a>
    );
}

function HeroStoreBadge({ href, icon: Icon, eyebrow, label, onClick }) {
    return (
        <ExternalLink href={href} className="store-badge" onClick={onClick} ariaLabel={label}>
            <span className="store-badge__icon" aria-hidden="true">
                <Icon width="18" height="18" />
            </span>
            <span className="store-badge__copy">
                <span className="store-badge__eyebrow">{eyebrow}</span>
                <span className="store-badge__label">{label}</span>
            </span>
        </ExternalLink>
    );
}

function StorePill({ href, icon: Icon, label, className, trail: TrailIcon, onClick }) {
    return (
        <ExternalLink href={href} className={className} onClick={onClick} ariaLabel={label}>
            <span className="store-pill__icon" aria-hidden="true">
                <Icon width="18" height="18" />
            </span>
            <span>{label}</span>
            <TrailIcon className="store-pill__trail" size={15} />
        </ExternalLink>
    );
}

export default function StoreCtaButtons({ variant = 'hero', onButtonClick }) {
    const platform = useStorePlatform();
    const preferredHref = platform === STORE_PLATFORMS.ANDROID ? storeLinks.android : storeLinks.ios;

    if (variant === 'nav') {
        return (
            <ExternalLink href={preferredHref} className="site-nav__cta store-download-pill" onClick={onButtonClick}>
                Download
            </ExternalLink>
        );
    }

    if (variant === 'cta' || variant === 'menu') {
        return (
            <div className="store-pill-group">
                {ctaButtons.map((button) => (
                    <StorePill key={button.label} {...button} onClick={onButtonClick} />
                ))}
            </div>
        );
    }

    return (
        <div className="store-badge-group">
            {heroButtons.map((button) => (
                <HeroStoreBadge key={button.label} {...button} onClick={onButtonClick} />
            ))}
        </div>
    );
}
